module.exports = __webpack_public_path__ + "app/img/xbox.a1e33898f3.svg";